import { localize } from 'b2b-common/vue-config/vee-validate'
import { veeValidateLangMapping, translateConfig } from './translate'

import en from 'vee-validate/dist/locale/en.json'
import bg from 'vee-validate/dist/locale/bg.json'
import sq from 'vee-validate/dist/locale/sq.json'
import sr from 'vee-validate/dist/locale/sr.json'

localize({ en, sq, bg, sr })

localize(veeValidateLangMapping[translateConfig.defaultLanguage])
